import { render, staticRenderFns } from "./submitPrompt.vue?vue&type=template&id=3ce1a80a&scoped=true&"
import script from "./submitPrompt.vue?vue&type=script&lang=js&"
export * from "./submitPrompt.vue?vue&type=script&lang=js&"
import style0 from "./submitPrompt.vue?vue&type=style&index=0&id=3ce1a80a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce1a80a",
  null
  
)

export default component.exports